import { createSelector } from 'reselect'
import entryDataRequestIsPendingSelector from '../pending-request/entryDataRequestIsPendingSelector'
import vehicleCodeRequestIsPendingSelector from '../pending-request/vehicleCodeRequestIsPendingSelector'
import shallAppRenderSelector from '../shallAppRenderSelector'
import showErrorPageSelector from '../showErrorPageSelector'
import userGarageStoreVehicleRequestIsPendingSelector
    from '../pending-request/userGarageStoreVehicleRequestIsPendingSelector'
import prStringRequestIsPendingSelector from '../pending-request/prStringRequestIsPendingSelector'
import vinRequestIsPendingSelector from '../pending-request/vinRequestIsPendingSelector'

const showGlobalLoadingIndicatorSelector = createSelector(
    shallAppRenderSelector,
    entryDataRequestIsPendingSelector,
    vehicleCodeRequestIsPendingSelector,
    userGarageStoreVehicleRequestIsPendingSelector,
    prStringRequestIsPendingSelector,
    vinRequestIsPendingSelector,
    showErrorPageSelector,
    (
        shallAppRender,
        entryDataRequestIsPending,
        vehicleCodeRequestIsPending,
        userGarageStoreVehicleRequestIsPending,
        prStringRequestIsPending,
        vinRequestIsPending,
        showErrorPage,
    ): boolean => (
        (
            !shallAppRender
            || entryDataRequestIsPending
            || vehicleCodeRequestIsPending
            || userGarageStoreVehicleRequestIsPending
            || prStringRequestIsPending
            || vinRequestIsPending
        ) && !showErrorPage
    ),
)

export default showGlobalLoadingIndicatorSelector
